<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="type ==='edit' ? $t('lang.customermanagement.CustomerAttributes') : $t('lang.customermanagement.news')"
      :visible.sync="dialogVisible"
      width="40%"
      center>
      <div class="form_content">
        <el-form :model="setCustomer" ref="customerForm" :rules="rules" label-width="140px">
          <el-form-item :label="`${$t('lang.customermanagement.customerName')}：`" prop="c_name">
             <el-input size="mini" class="adduserinput" v-model="setCustomer.c_name"></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.customermanagement.userDisplay')}：`" prop="userRoleid">
            <el-select
              v-model="setCustomer.userRoleid"
              :placeholder="$t('lang.customermanagement.specifiedwill')"
              size="mini"
              class="adduserinput">
              <el-option
                v-for="item in roleId"
                :key="item.roleId"
                :label="item.roleName"
                :value="(item.roleId).toString()">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.customermanagement.HomeThis')}：`" prop="cUrl">
            <el-input
              size="mini"
              class="adduserinput"
              v-model="setCustomer.cUrl"
              :placeholder="$t('lang.customermanagement.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.customermanagement.Contact')}：`" prop="cContact">
            <el-input
              size="mini"
              class="adduserinput"
              v-model="setCustomer.cContact"
              :placeholder="$t('lang.customermanagement.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.customermanagement.phone')}：`" prop="cTel">
            <el-input
              size="mini"
              class="adduserinput"
              v-model="setCustomer.cTel"
              :placeholder="$t('lang.customermanagement.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.customermanagement.ADDRESS')}：`" prop="cStreet">
            <el-input
              size="mini"
              class="adduserinput"
              v-model="setCustomer.cStreet"
              :placeholder="$t('lang.customermanagement.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.customermanagement.detailed')}：`" prop="cAddress">
            <el-input
              size="mini"
              class="adduserinput"
              v-model="setCustomer.cAddress"
              :placeholder="$t('lang.customermanagement.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.customermanagement.Email')}：`" prop="cEmail">
            <el-input
              size="mini"
              class="adduserinput"
              v-model="setCustomer.cEmail"
              :placeholder="$t('lang.customermanagement.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item label="Logo：">
             <div style="width:100%">
              <el-upload
                ref="upload"
                class="avatar-uploader"
                action="/api/customer/uploadImage"
                :show-file-list="false"
                :auto-upload="false"
                :headers="Headers"
                :data="CustomerLogoId"
                :on-change="GetLocalHostUrl"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" style="display:block;margin:0 auto;">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item :label="$t('lang.customermanagement.copyrightInformation')" >
            <el-input class="adduserinput" v-model="setCustomer.copyRight" size="mini"></el-input>
            <p style="font-size: 12px;">{{$t('lang.customermanagement.template')}}</p>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false" >{{$t('lang.customermanagement.cancel')}}</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="subimitForm">
          {{$t('lang.customermanagement.Determine')}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { newCustomer, getFunctionalAuthority, updateCustomer } from "@/api/customermanagement";
import { cloneDeep, isEqual } from 'lodash'
import { getPermission,getToken } from "@/cookie/cookie";

export default {
  data() {
    return {
      dialogVisible: false,
      // 表单数据
      setCustomer: {
        cEmail: '',
        cAddress: '',
        cStreet: '',
        cTel: '',
        cContact: '',
        cUrl: '',
        userRoleid: '',
        c_name: '',
        c_id: '',
      },
      roleId: [],
      //上传添加token
      Headers:{
        token:getToken()
      },
      CustomerLogoId: { customerId: "" },
      type: '',
      // 表单验证规则
      rules: {
        c_name: [ {required: true, message: this.$t('lang.customermanagement.inputName'), trigger: 'blur'} ],
        userRoleid: [{ required: true, message: this.$t('lang.customermanagement.selectRole'), triggerL: 'change'}]
      },
      //Logo(保存base64展示，提交获取文件)
      imageUrl: "",
      //logo(保存logo文件，提交赋值imageUrl)
      ImgBase: "",
      updateSuccess: false, // 请求成功后才上传图片到服务器
      // 原始数据，判断是否有内容被修改
      originalData: {},
      originalImage: ''
    }
  },
  methods: {
    // 清空数据，防止点击编辑后，再点击添加，表单项会显示编辑表单的数据
    clearData() {
      this.setCustomer = {
        cEmail: '',
        cAddress: '',
        cStreet: '',
        cTel: '',
        cContact: '',
        cUrl: '',
        userRoleid: '',
        c_name: '',
        c_id: '',
      },
      this.imageUrl = ''
      this.ImgBase = ''
      this.originalData = {},
      this.originalImage = ''
      this.CustomerLogoId = { customerId: "" }
    },
    show(item) {
      this.clearData()
      this.dialogVisible = true // 视图更新了
      this.getRole()
      //在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。(在更新后的视图上进行操作)
      // 在DOM渲染完成后仔赋值，ref只在组件渲染完成后生效，不使用nextTick，后面的this.$refs会出现undefind
      this.$nextTick(() => {
        if(item) {
          this.type = 'edit'
          this.setCustomer = cloneDeep(item) 
          this.imageUrl = item.cLogo;
          this.CustomerLogoId.customerId = item.c_id
        }else{
          this.type = 'add'
        }
        this.originalData = cloneDeep(this.setCustomer)
        this.originalImage = cloneDeep(this.imageUrl)
      })

    },
    subimitForm(){
      if(!isEqual(this.originalImage, this.imageUrl) || !isEqual(this.originalData, this.setCustomer)) {
        // 验证表单规则是否正确
        this.$refs['customerForm'].validate((valid) => {
          if(valid){
            // 编辑
            if(this.setCustomer.c_id){
              this.editCustomer()
            }else{ // 添加
              this.addCustomer()
            }
          }else{
            return false
          }
        })
      }else{
        this.$message({
          type: 'warning',
          message: this.$t('lang.customermanagement.notEdit')
        })
      }
    },
    //修改客户上传
    editCustomer() {
      updateCustomer(this.setCustomer).then(res => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.customermanagement.message12"),
            type: "success"
          });
          //获取Logo文件上传
          this.imageUrl = this.ImgBase;
          //提交客户logo
          //提交客户logo
          if(this.imageUrl){
            this.$refs.upload.submit();
          }
          this.$emit('queryKeyword')
          this.dialogVisible = false
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.customermanagement.message13"),
            type: "warning"
          });
          this.dialogVisible = false
        }
      });
    },
    //新增
    addCustomer() {
       //新增客户接口
      newCustomer(this.setCustomer, this.$i18n.locale == "en-US" ? 1 : 0).then(
        res => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t("lang.customermanagement.message1"),
              type: "success"
            });
            //获取Logo文件上传
            this.imageUrl = this.ImgBase;
            //获取新建客户的id
            this.CustomerLogoId.customerId = res.data.data.customerId;
            //提交客户logo
            if(this.imageUrl){
              this.$refs.upload.submit();
            }
            // this.$emit('getList')
             this.$emit('queryKeyword')
          } else if (res.data.code === 3) {
            this.$message({
              showClose: true,
              message: this.$t("lang.customermanagement.message2"),
              type: "warning"
            });
            // this.$emit('getList')
             this.$emit('queryKeyword')
          } else if (res.data.code === 6) {
            this.$message({
              showClose: true,
              message: this.$t("lang.customermanagement.message3"),
              type: "warning"
            });
            // this.$emit('getList')
             this.$emit('queryKeyword')
          } else if (res.data.code === 18) {
            this.$message({
              showClose: true,
              message: this.$t("lang.customermanagement.message4"),
              type: "warning"
            });
            // this.$emit('getList')
             this.$emit('queryKeyword')
          } else if (res.data.code === 7) {
            this.$message({
              showClose: true,
              message: this.$t("lang.customermanagement.message5"),
              type: "warning"
            });
            // this.$emit('getList')
             this.$emit('queryKeyword')
          } else if (res.data.code === 8) {
            this.$message({
              showClose: true,
              message: this.$t("lang.customermanagement.message6"),
              type: "warning"
            });
            // this.$emit('getList')
             this.$emit('queryKeyword')
          } else if (res.data.code === 28) {
            this.$message({
              showClose: true,
              message: this.$t("lang.customermanagement.message7"),
              type: "warning"
            });
            // this.$emit('getList')
             this.$emit('queryKeyword')
          } else {
            this.$message({
              showClose: true,
              message: this.$t("lang.customermanagement.message8"),
              type: "warning"
            });
            // this.$emit('getList')
             this.$emit('queryKeyword')
          }
          this.dialogVisible = false
        });
    },
    getRole() {
      //获取中文或英文的权限列表
      getFunctionalAuthority(this.$i18n.locale == "en-US" ? 1 : 0).then(res => {
        this.roleId = res.data.data.list;
      });
    },
    //图片上传
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error(this.$t('lang.customermanagement.imgFormate'));
        return;
      }
      if (!isLt2M) {
        this.$message.error(this.$t('lang.customermanagement.imgSize'));
        return;
      }
    },
    //logo上传
    handleAvatarSuccess(res, file) {
      this.$emit('queryKeyword')
    },
     //图片上传后
    GetLocalHostUrl(file, fileList) {
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error(this.$t('lang.customermanagement.LogoFormate'));
        return;
      }
      if (!isLt2M) {
        this.$message.error(this.$t('lang.customermanagement.LogoSize'));
        return;
      }
      this.ImgBase=file.raw
      var event = event || window.event;
      var file = event.target.files[0];
      var reader = new FileReader();
      //转为base64显示
      reader.onload = e => {
        this.imageUrl = e.target.result; //将图片路径赋值给src
      };
      reader.readAsDataURL(file);
    },
  }
}
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.adduserinput {
  width: 250px;
}
.form_content{
  display: flex;
  justify-content: center;
}
.el-form-item {
  margin-bottom: 10px;
}
</style>